module.exports = __webpack_public_path__ + "img/bk.c19307e7.png";